import React, { useState } from "react";
import Search from "../include/Search";
import Specialities from "./partials/Specialities";
import "./SpecialitiesList.css";

const SpecialitiesList = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="specialities-list-section">
      <Search onSearch={(value) => setSearch(value)} />
      <Specialities search={search} />
    </div>
  );
};

export default SpecialitiesList;
